import * as Sentry from '@sentry/nuxt'
import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', () => {
  const feedbackOpen = ref(false)
  const lead_limit = ref(0)
  const lead_term = ref(0)
  const queryParams = ref({})
  const route = useRoute()

  queryParams.value = route.query

  watch(
    () => route.query,
    (newQuery) => {
      queryParams.value = newQuery
    },
  )

  async function goToAnketaLink() {
    try {
      const response = await $fetch<any>('/api/getLink', {
        method: 'POST',
        body: {
          ...queryParams.value,
          lead_limit: lead_limit.value.toString(),
          lead_term: lead_term.value.toString(),
        },
      })

      if (response?.redirect) {
        // Логируем успешное получение ссылки
        Sentry.addBreadcrumb({
          category: 'navigation',
          message: 'Successfully got anketa link',
          level: 'info',
          data: {
            lead_limit: lead_limit.value,
            lead_term: lead_term.value,
          },
        })

        navigateTo(response.redirect, { external: true })
      }
      else {
        // Если нет redirect в ответе
        Sentry.captureMessage('No redirect URL in getLink response', 'warning')
      }
    }
    catch (error) {
      console.error('Error getting anketa link:', error)

      // Отправляем ошибку в Sentry с контекстом
      Sentry.withScope((scope) => {
        scope.setTag('store', 'main')
        scope.setTag('action', 'get_anketa_link')
        scope.setContext('request_data', {
          lead_limit: lead_limit.value,
          lead_term: lead_term.value,
          query_params: queryParams.value,
        })
        Sentry.captureException(error)
      })

      // Fallback - перенаправляем на основную страницу заявки
      navigateTo('https://lk.nebusfinance.ru/step-first', { external: true })
    }
  }

  return {
    feedbackOpen,
    setFeedbackOpen: (value: boolean) => (feedbackOpen.value = value),
    queryParams,
    goToAnketaLink,
    lead_limit,
    lead_term,
  }
})
